import React from 'react';
import { Grid } from '@mui/material';
import { email, SelectInput, TextInput } from 'react-admin';
import lineOfBusinessTypeChoices from '../constants/lineOfBusinessTypeChoices';
import { countryChoices } from '../../../../constants/countries';
import languages from '../../../../constants/languages';

const LineOfBusinessProductInformation = () => (
  <Grid container spacing={6}>
    <Grid size={12}>
      <TextInput
        source="productInformation.name"
        label="Name"
      />
    </Grid>
    <Grid size={12}>
      <SelectInput
        source="productInformation.type"
        label="Type"
        choices={lineOfBusinessTypeChoices}
      />
    </Grid>
    <Grid size={12}>
      <Grid container spacing={6}>
        <Grid>
          <TextInput
            source="productInformation.contactInfo.address.streetAddress"
            label="Streed address"
          />
        </Grid>
        <Grid>
          <TextInput
            source="productInformation.contactInfo.address.postalCode"
            label="Postal code"
          />
        </Grid>
        <Grid>
          <TextInput
            source="productInformation.contactInfo.address.city"
            label="City"
          />
        </Grid>
        <Grid>
          <SelectInput
            source="productInformation.contactInfo.address.country"
            label="Country"
            choices={countryChoices(languages.EN)}
          />
        </Grid>
      </Grid>
    </Grid>
    <Grid size={12}>
      <TextInput
        source="productInformation.contactInfo.email"
        validate={[email()]}
        label="Email"
      />
    </Grid>
    <Grid size={12}>
      <TextInput
        source="productInformation.contactInfo.phone"
        label="Phone"
      />
    </Grid>
  </Grid>
);

export default LineOfBusinessProductInformation;
